// client/src/components/forms/FormField.js
//
// Wrapper for a single form field: uppercase eyebrow label on top, the
// input as children in the middle, optional helper nudge in Scrawl below,
// optional error in red below that. Error replaces helper — never stacked.
//
// Uses a native <label> so clicking anywhere on the chrome focuses the
// wrapped input. That works out-of-the-box for TextInput / Textarea /
// Select / DateTimePicker — all of which render a single focusable form
// control as their child.
//
// Checkbox does NOT use FormField — its label sits inline to the right
// of the checkbox itself, which is a fundamentally different layout.

import { Scrawl } from '../mischief/Scrawl';

export function FormField({ label, helperText, error, children }) {
  return (
    <label className="block">
      {label && (
        <span className="block text-eyebrow uppercase text-inkSub mb-2">
          {label}
        </span>
      )}
      {children}
      {helperText && !error && (
        <span className="block mt-1.5">
          <Scrawl size="sm" color="inkSub">{helperText}</Scrawl>
        </span>
      )}
      {error && (
        <span className="block mt-1.5 text-sm text-red">
          {error}
        </span>
      )}
    </label>
  );
}